import {phone} from '../../../../../filters/string'
import {AmToBr, brToAm, date} from '../../../../../filters/date'
import Account from '../../../../../services/account'
import Contact from './contact.vue';

export default {
  props: ['user', 'contact'],
  data() {
    return {
      address: undefined,
      taxIdNumberFormatted: undefined,
      fullName: undefined,
      birthDateBR: undefined,
      email: undefined,
      cel: undefined,
      tel: undefined
    }
  },
  mounted() {
    if(this.user && this.contact) { 
      this.email = this.contact.email;
      this.taxIdNumberFormatted = this.user.taxIdNumber;
      this.fullName = this.user.fullName;
      this.birthDateBR = AmToBr(this.user.birthDate || '');
      this.cel = phone(`${this.contact.dddCellphone} ${this.contact.nroCellphone}`);
      this.tel = phone(`${this.contact.dddPhone} ${this.contact.nroPhone}`);
    }
  },
  methods: {
    correctCursor2(a){
      if(!window.document.mobile)
        return;

      setTimeout(() => {
        $(a.target).val($(a.target).val());
      }, 80);
    },
    async userExists() {
      const resp = await Account.getUserAndAddressByTaxIdNumberAggregate(this.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase());
      this.fullName = resp.user.person.name + ' ' + resp.user.person.lastName;
      this.birthDateBR = date(resp.user.person.birthDate);
      this.email = resp.user.email2;
      this.cel = phone(resp.user.dddCellphone + resp.user.nroCellphone);
      this.address = resp.address;
      this.address.addressId = resp.address.addressId;

      if(resp.user.nroPhone == 0 && resp.user.dddPhone == 0) {
        this.tel = '';
      } else {
        this.tel = phone(`${resp.user.dddPhone} ${resp.user.nroPhone}`);
      }
    },
    validateAll(){
      return this.$validator.validateAll()
        .then(() => {
          this.user.fullName = this.fullName.trim();
          let firstSpace = this.fullName.indexOf(" ") || this.fullName.length;
          this.user.name = this.fullName.substring(0, firstSpace);
          this.user.lastName = this.fullName.substring(firstSpace + 1, this.fullName.length);
          this.user.birthDate = brToAm(this.birthDateBR);
          this.user.taxIdNumber = this.taxIdNumberFormatted.replace(/[.\-\/]/g, '').toUpperCase();
          this.contact.email = this.email;
          
          this.contact.nroCellphone = Number(this.cel.substring(4, this.cel.length).replace('-', '').trim());
          this.contact.nroPhone = Number(this.tel.substring(4, this.cel.length).replace('-', '').trim());
          this.contact.dddCellphone = Number(this.cel.substring(0, 4).replace('(', '').replace(')', ''));
          this.contact.dddPhone = Number(this.tel.substring(0, 4).replace('(', '').replace(')', ''));
        }).then(() => {
          if (this.address) {
            this.$emit('addressExists', this.address);
          }
        });
    }
  },
  components: {
    Contact
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/aggregate-register/user.js